import clsx from 'clsx'
import { Image } from '~/elements/Image/Image'
import { useTranslation } from 'next-i18next'
import { Menu, MenuList, MenuButton, MenuItem } from '@reach/menu-button'
import { Media } from '~/lib/Media'
type Num = 1 | 2 | 3 | 4 | 6
type Props = {
  isSearch?: boolean
  gridColumnsNumber: Num
  setGridColumnsNumber: (gridColumnsNumber: Num) => void
  className?: string
  setIsReady?: (bol: boolean) => void
}
export const GridToggle = ({
  setGridColumnsNumber,
  gridColumnsNumber,
  className,
  isSearch,
  setIsReady = () => {},
}: Props) => {
  const { t } = useTranslation()
  return (
    <div className={clsx('flex', className)}>
      <Media greaterThanOrEqual="lg">
        <Menu>
          {({ isExpanded }) => (
            <>
              <MenuButton className="flex flex-nowrap items-center">
                <span
                  className={clsx(
                    'mr-3 text-p text-primary-black',
                    isSearch ? 'font-extralight' : 'font-medium',
                  )}
                >
                  {t('View')}
                </span>
                <span aria-hidden="true">
                  <div
                    className={clsx(isSearch && 'h-18px w-[18px] rounded-full bg-sg-grey p-0.5')}
                  >
                    <Image
                      src="/images/Icons/chevron-down.svg"
                      width={24}
                      height={24}
                      placeholder="empty"
                      className={clsx('transition', isExpanded ? 'rotate-180' : '')}
                      alt="chevron-icon"
                    />
                  </div>
                </span>
              </MenuButton>
              <MenuList className="relative border-grey-border p-0" style={{ zIndex: 999999 }}>
                <MenuItem
                  className={clsx(
                    gridColumnsNumber !== 6 ? 'text-grey-dark' : 'font-medium text-primary-black',
                  )}
                  onSelect={() => {
                    setGridColumnsNumber(6)
                    setIsReady(true)
                  }}
                >
                  <span className="flex flex-nowrap items-center gap-[6px]">
                    <Image
                      src="/images/Icons/cols-6.svg"
                      width={11}
                      height={12}
                      placeholder="empty"
                      alt="cols6-icon"
                    />{' '}
                    6 {t('Columns')}
                  </span>
                </MenuItem>
                <MenuItem
                  className={clsx(
                    gridColumnsNumber !== 4 ? 'text-grey-dark' : 'font-medium text-primary-black',
                  )}
                  onSelect={() => {
                    setGridColumnsNumber(4)
                    setIsReady(true)
                  }}
                >
                  <span className="flex flex-nowrap items-center gap-[6px]">
                    <Image
                      src="/images/Icons/cols-4.svg"
                      width={11}
                      height={12}
                      placeholder="empty"
                      alt="cols4-icon"
                    />{' '}
                    4 {t('Columns')}
                  </span>
                </MenuItem>
                <MenuItem
                  className={clsx(
                    gridColumnsNumber !== 3 ? 'text-grey-dark' : 'font-medium text-primary-black',
                  )}
                  onSelect={() => {
                    setGridColumnsNumber(3)
                    setIsReady(true)
                  }}
                >
                  <span className="flex flex-nowrap items-center gap-[6px]">
                    <Image
                      src="/images/Icons/cols-3.svg"
                      width={11}
                      height={12}
                      placeholder="empty"
                      alt="cols3-icon"
                    />{' '}
                    3 {t('Columns')}
                  </span>
                </MenuItem>
              </MenuList>
            </>
          )}
        </Menu>
      </Media>
      <Media lessThan="lg">
        <button
          title={t('Change products view')}
          onClick={() => {
            setGridColumnsNumber(gridColumnsNumber === 1 ? 2 : 1)
            setIsReady(true)
          }}
        >
          <Image
            src={`/images/Icons/product-view-${gridColumnsNumber === 1 ? 'two' : 'one'}.svg`}
            width={24}
            height={25}
            placeholder="empty"
            alt="usp-icon"
            className="mt-2"
          />
        </button>
      </Media>
    </div>
  )
}
